import { combineReducers } from "redux";
import join from "../modules/join";
import specialCheck from "../modules/specialCheck";

const rootReducer = combineReducers({
  join,
  specialCheck,
});

export default rootReducer;
